//import Vue from 'vue';
import JsEncrypt from 'jsencrypt';

//Vue.prototype.$jsEncrypt = JsEncrypt;

let jse = new JsEncrypt();

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDEaUpPgdikQxGhlmqcOSN3UdDKUNZ/OnwONtgPOtctkh0i2KxAj73fawJfGe2C20EiDFrSgdkF6AYf1livYLvify0ZRfi/K+Ic5Kr8xUkYATJEjP7YrAX3TTzDzUQQoSGdsobO3Oxcx3eimHEhnIvjMTnW4au6KHJamdcUUSkGJwIDAQAB';
const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBALfov3HxABb59V6IY0NBUGIy30h3quamnFuw9gXsLp1dS+4MQBFdxGyEg4JPHdFEI02RMvVAWosZ8/1R6dQJZS8yWhHrI4Cxp8duAOMLmqn6z6vEMDYxXkU4Q1FJ5h9uhw9uA8LQbLhzDf9+WWoZ5B0EFfu0b57HnQC3xHgMfm5jAgMBAAECgYAWyI/HFtsy/X5nWrApadMCh1jgCmsyrdtbBJ5F94+C0UcR05SwUhR+eSAtqY2BGlbhSias+W7+IpX2gQpdyVgufWiNafWTUo4L9FgkYQxn1GVrbUn9y2x/bP2eZ5OuKei7HDfqPq3+OVo0iqs+QyULkx/QaYWHpJk8PKZ8v8fnmQJBAPgasEybcmBho8+8aOnteZqMpwWNFkxs5498z9yMKkCWejCH/JcCbQTdRV9kvC6t3mvLH4WU7VdxIG8+kOQcha8CQQC9ww9u85llgVaXbBa1V8aAUiiy/TS5IxhOqJH5iRK8pv0zC8L9RzQmUVVaFUjZi3tJY8Cta+NY//18Damp9EONAkEAkxvoCxRkpide5Q73OjVX1D6vzgfQ//HW/2pnKYNmjjNrMhl/uN50W90DhEOLnTX02v9uqlsau61VKQD1Enyi+wJAaapNVL3mg+QiYIz6lB39VYTqTsi57AGDzoEFT8spGM1vnlYFTN2yR0fw3AmQGDsX+oTGTIsP/IYHE2XUPOPcHQJAeJJ8w/eHvlCo3x80gaJeBr3n7AfX0sRAtmDDFm9uwk3YJYEbdsqEL//oEhfU61dfAcVOCm4GKA2NAHF8Gf7jOg==';


export default {
    rsaEncrypt(src){
        jse.setPublicKey(publicKey);
        return jse.encrypt(src);
    },
    rsaDecrypt(cipher){
        jse.setPrivateKey(privateKey);
        return jse.decrypt(cipher);
    }
}
